export default __webpack_public_path__ + "static/media/email.43c98fad.svg";